module.exports = __webpack_public_path__ + "img/IMG-20191106-WA0009.41a86046.jpg";